import { PTRelation } from '@/features/publicMember/types';

const MemberCoachOnboardingChip = ({
    relation,
}: {
    relation?: Pick<PTRelation, 'onboardingPending'>;
}) => {
    if (relation?.onboardingPending !== true) return null;

    const title = '회원이 앱에서 정보 입력 전이에요';

    return (
        <span
            role="note"
            tabIndex={0}
            title={title}
            aria-label={`가입 진행 중: ${title}`}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                // 테두리를 포함해 대표 강사 칩의 3px 8px 패딩과 크기를 맞춘다.
                padding: '2px 7px',
                border: '1px solid #E2E8F0',
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 700,
                backgroundColor: '#F8FAFC',
                color: '#64748B',
            }}
        >
            가입 진행 중
        </span>
    );
};

export default MemberCoachOnboardingChip;
